import router from './router';
import store from './store';
import { Message } from 'element-ui';
import { getToken } from '@/utils/auth';
import { getMenuData } from '@/api/user';
import { getConfigKey } from '@/api/common';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
NProgress.configure({ showSpinner: false });

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  store.commit('SET_FULL_LOADING', true);
  if (!store.state.menuList.length) {
    await getMenuData().then((res) => {
      res.data.unshift({ name: '首页' });
      store.state.menuList = res.data;
    });
  }
  if(to.path === '/personal' && !getToken()) {
    next({ path: '/' });
    return;
  }
  // getConfigKey('sub.central.phone').then((res) => {
  //   store.state.centralPhone = res.msg;
  // });
  if (getToken() && store.state.userInfo && Object.keys(store.state.userInfo).length === 0) {
    store
      .dispatch('GetInfo')
      .then(() => {
        // const loading = document.getElementById('loader-wrapper');
        // if (loading) {
        //   document.body.removeChild(loading);
        // }
        // const icon = document.getElementById('loading-icon');
        // if (icon) {
        //   document.body.removeChild(icon);
        // }
            setTimeout(() => {
              store.commit('SET_FULL_LOADING', false);
              next();
              NProgress.done();
            }, 400);
      })
      .catch((err) => {
        store.dispatch('LogOut').then(() => {
          Message.error(err);
          next({ path: '/' });
        });
      });
  } else {
    // const loading = document.getElementById('loader-wrapper');
    // if (loading) {
    //   document.body.removeChild(loading);
    // }
    // const icon = document.getElementById('loading-icon');
    // if (icon) {
    //   document.body.removeChild(icon);
    // }
    setTimeout(() => {
    store.commit('SET_FULL_LOADING', false);
    next();
    NProgress.done();

    }, 400)
  }
});

router.afterEach(() => {
  NProgress.done();
});
